import { Select, Group } from "@mantine/core";
import { IconWorld } from "@tabler/icons-react";
import { useLanguage } from "../services/LanguageContext";

const languageLabels = {
  en: "English",
  sr: "Serbian",
};

const languageFlags = {
  en: "🇺🇸",
  sr: "🇷🇸",
};

export default function LanguageSelector({ variant = "default", size = "sm" }) {
  const { language, setLanguage } = useLanguage();

  const selectData = Object.keys(languageLabels).map((lang) => ({
    value: lang,
    label:
      `${languageFlags[lang] || ""} ${languageLabels[lang] || lang.toUpperCase()}`.trim(),
  }));

  if (variant === "compact") {
    return (
      <Select
        data={selectData}
        value={language}
        onChange={setLanguage}
        size={size}
        variant="unstyled"
        style={{ width: 150 }}
        rightSection={null}
        allowDeselect={false}
        styles={{
          input: {
            border: "none",
            padding: "4px 8px",
            fontSize: "14px",
            fontWeight: 500,
          },
        }}
      />
    );
  }

  return (
    <Group gap="xs">
      <IconWorld size={16} />
      <Select
        data={selectData}
        value={language}
        onChange={setLanguage}
        size={size}
        placeholder="Select language"
        style={{ minWidth: 180 }}
        allowDeselect={false}
      />
    </Group>
  );
}
